import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';

import { OrganizationService } from '../../../services/organization.service';
import { ToastComponent } from '../../toast/toast.component';
import { Organization } from '../../models/organization.model';
import { ee } from '../../constants';
import { setClassInvalidTpl } from '../../functions';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-edit-organization-modal',
  templateUrl: './edit-organization-modal.component.html',
  standalone: false
})
export class EditOrganizationModalComponent implements OnInit, OnDestroy {
  toast = inject(ToastComponent);
  private organizationService = inject(OrganizationService);


  @Input() organization: Organization;
  @Input() field = '';

  setClassInvalidTpl = setClassInvalidTpl;

  ngOnInit(): void {
    // This is executed N+1 times, to fix eventually
    ee.on('showEditOrganizationModal', (field: string) => this.field = field);
  }

  ngOnDestroy(): void {
    ee.off('showEditOrganizationModal', () => {});
  }

  updateOrganization(field: string): void {
    const organization: Organization = {
      _id: this.organization._id,
      [field]: this.organization[field]
    };
    this.organizationService.update(organization)
      .pipe(finalize(() => ee.emit('getOrganization')))
      .subscribe({
        next: res => this.toast.setMessage('Organization updated successfully', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }


}
